import { RiskAssessmentEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';
import GuestAxiosManager from 'shared/manager/GuestAxiosManager';

const submitRiskAssessment = async (data: any): Promise<any> =>
  APIManager.sendPost(
    RiskAssessmentEnds.POST_ASSESSMENT,
    data,
    true,
    {},
    {},
    axios
  );

const submitRiskAssessmentResponse = async (data: any): Promise<any> =>
  APIManager.sendPut(
    RiskAssessmentEnds.POST_ASSESSMENT_RESPONSE,
    data,
    true,
    {},
    {},
    axios
  );

const getAssessmentTemplates = async (): Promise<any> =>
  APIManager.sendGet(RiskAssessmentEnds.TEMPLATES, true, {}, {}, axios);

const getAssessmentDetail = async (assessmentId: string): Promise<any> =>
  APIManager.sendGet(
    `${RiskAssessmentEnds.GET_ASSESSMENTS}/${assessmentId}`,
    true,
    {},
    {},
    axios
  );

const getRiskAssessments = async (): Promise<any> =>
  APIManager.sendGet(RiskAssessmentEnds.GET_ASSESSMENTS, true, {}, {}, axios);

const getLinkedAssessments = async (
  datasetId: string,
  aiSystemId: string
): Promise<any> =>
  APIManager.sendGet(
    `${RiskAssessmentEnds.LINKED_ASSESSMENTS}/${datasetId}/${aiSystemId}`,
    true,
    {},
    {},
    axios
  );

const createAssessmentTemplate = async (data: any): Promise<any> =>
  APIManager.sendPost(
    RiskAssessmentEnds.CREATE_TEMPLATE,
    data,
    true,
    {},
    {},
    axios
  );

const getCustomAssessmentTemplates = async (
  queryString: string
): Promise<any> =>
  APIManager.sendGet(
    RiskAssessmentEnds.GET_CUSTOM_TEMPLATES(queryString),
    true,
    {},
    {},
    axios
  );

const updateAssessmentTemplate = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    RiskAssessmentEnds.UPDATE_TEMPLATE(id),
    data,
    true,
    {},
    {},
    axios
  );

const getAssessmentTemplateDetail = async (templateId: string): Promise<any> =>
  APIManager.sendGet(
    RiskAssessmentEnds.GET_CUSTOM_TEMPLATE_BY_ID(templateId),
    true,
    {},
    {},
    axios
  );

const deleteTemplate = async (id: string): Promise<any> =>
  APIManager.sendDelete(
    RiskAssessmentEnds.DELETE_TEMPLATE_BY_ID(id),
    true,
    {},
    {},
    axios
  );

const sendAssessment = async (payload: any): Promise<any> =>
  APIManager.sendPost(
    RiskAssessmentEnds.SEND_ASSESSMENT,
    payload,
    true,
    {},
    {},
    axios
  );

const getExternalAssessments = async (queryParams: string): Promise<any> =>
  APIManager.sendGet(
    RiskAssessmentEnds.GET_EXTERNAL_ASSESSMENTS(queryParams),
    true,
    {},
    {},
    axios
  );

const getExternalAssessmentStats = async (): Promise<any> =>
  APIManager.sendGet(
    RiskAssessmentEnds.GET_EXTERNAL_ASSESSMENTS_STATS,
    true,
    {},
    {},
    axios
  );

const deleteExternalAssessment = async (id: string): Promise<any> =>
  APIManager.sendDelete(
    RiskAssessmentEnds.DELETE_ASSESSMENT_BY_ID(id),
    true,
    {},
    {},
    axios
  );

const getExternalAssessmentDetail = async (
  assessmentId: string
): Promise<any> =>
  APIManager.sendGet(
    RiskAssessmentEnds.GET_EXTERNAL_ASSESSMENT_DETAIL(assessmentId),
    true,
    {},
    {},
    axios
  );

// Guest API's
const getExternalAuthToken = async (data: any): Promise<any> =>
  APIManager.sendPost(
    RiskAssessmentEnds.GET_EXTERNAL_AUTH,
    data,
    false,
    {},
    {},
    axios
  );

const getGuestExternalAssessmentDetail = async (): Promise<any> =>
  APIManager.sendGet(
    RiskAssessmentEnds.GET_GUEST_EXTERNAL_ASSESSMENT_DETAIL,
    true,
    {},
    {},
    GuestAxiosManager
  );

const completeExternalAssessment = async (data: any): Promise<any> =>
  APIManager.sendPost(
    RiskAssessmentEnds.COMPLETE_EXTERNAL_ASSESSMENT_DETAIL,
    data,
    true,
    {},
    {},
    GuestAxiosManager
  );

export const RiskAssessmentService = {
  submitRiskAssessment,
  submitRiskAssessmentResponse,
  getAssessmentDetail,
  getAssessmentTemplates,
  getRiskAssessments,
  getLinkedAssessments,
  createAssessmentTemplate,
  getCustomAssessmentTemplates,
  updateAssessmentTemplate,
  getAssessmentTemplateDetail,
  deleteTemplate,
  sendAssessment,
  getExternalAssessments,
  getExternalAssessmentStats,
  deleteExternalAssessment,
  getExternalAuthToken,
  getExternalAssessmentDetail,
  completeExternalAssessment,
  getGuestExternalAssessmentDetail,
};
